import { Visualizador } from 'app/main/publico/PDF';
import { publicoApi } from 'app/services/api/publicoApi';
import React from 'react';

async function buscarArquivo(credentials, tenantId, setArquivo) {
  const response = await publicoApi().pedidoCompraProduto(credentials, tenantId);
  setArquivo(response.data.arquivo);
}

const VisualizarPedidoCompra = () => {
  return <Visualizador buscarArquivo={buscarArquivo} nomeArquivo="pedido_compra" />;
};

export default VisualizarPedidoCompra;
